export default (path, target = '_self') => {
  if (typeof window !== 'undefined') {
    window.open(path, target);
  }
};
